import { API } from 'aws-amplify'

export interface CatalogApartment {
  code: string
  address?: string
  district?: string
  postalCode?: string
  municipality: string
  rooms?: string
  kitchen?: string
  squareMeters?: number
  floor?: number
  floors?: number
  buildingType?: string
  buildYear?: number
  condition?: string
  balcony?: string
  sauna?: string
  parking?: string
  dishwasher?: string
  laundryMachine?: string
  heating?: string
  petsAllowed?: string
  storage?: string
  hasElevator: boolean
  hasTerrace: boolean
  isFurnished: boolean
  hasLaundromat: boolean
  internetIncluded: boolean
  groupsPossible: boolean
  hasBuiltInCloset?: boolean
  energyCertification?: string
  description: string
  descriptionEn?: string
  price?: number
  waterFee?: number
  waterFeeBasis?: string
  parkingFee?: number
  securityDeposit?: string
  securityDepositAmount?: number
  rentPeriod?: string
  availableFromDate?: string
  availableUntilDate?: string
  images: string[]
  publishedAt?: number
}

interface CatalogResponse {
  apartments: CatalogApartment[]
}

const MAX_AGE_MS = 60 * 1000
let cached: { at: number; promise: Promise<CatalogResponse> } | undefined

/** Shared by the list and the listing page so moving between them needs no refetch. */
const getCatalog = (force = false): Promise<CatalogResponse> => {
  if (!force && cached && Date.now() - cached.at < MAX_AGE_MS) {
    return cached.promise
  }
  const promise: Promise<CatalogResponse> = API.get('apartments', '/apartments/public/catalog', {})
  cached = { at: Date.now(), promise }
  promise.catch(() => {
    cached = undefined
  })
  return promise
}

export default { getCatalog }
